import SliderProduct from '../../services/SliderProduct';

export default {
    namespaced: false,
    state: {
        products: []
    },
    mutations: {
        SET_PRODUCTS(state, data) {
            state.products = data;
        }
    },
    actions: {
        getProductSlider({ commit }, data) {
            const response = SliderProduct.getProductSlider(data);
            response.then(res => {
                commit('SET_PRODUCTS', res.data);
            });
        },
        getSingleProductSlider({ commit }, id) {
            const response = SliderProduct.getSingleProductSlider(id);
            response.then(res => {
                commit('SET_PRODUCTS', res.data);
            });
        }
    }
};
